import { AppSidebar } from "./AppSidebar"
import { Outlet } from "react-router-dom"

export const DashboardLayout = () => {
  return (
    <div className="z-50 flex h-screen w-full bg-dark">
      <AppSidebar />
      <main className="h-full w-full overflow-auto">
        <Outlet />
      </main>
    </div>
  )
}
